import React, { Component } from "react";
import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Logo200 from "../Logomarca/logo200";
import Logo300 from "../Logomarca/logo300";
import NavDropdown from 'react-bootstrap/NavDropdown';
import { HashLink as Link } from 'react-router-hash-link';

export default class Novomenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      navExpanded: false
    };
  }

  setNavExpanded = (expanded) => {
    this.setState({ navExpanded: expanded });
  }

  setNavClose = () => {
    this.setState({ navExpanded: false });
  }

  render() {
    return (
      <div className="bg-topo" id="menu">
      <Container fluid>
         <Navbar className="pt-3 text-white" expand="lg" onToggle={this.setNavExpanded} expanded={this.state.navExpanded}>
               <Navbar.Brand>
                  <div className="d-block d-sm-none">
                     <Logo200 />
                  </div>
                  <div className="d-none d-sm-block">
                     <Logo300 />
                  </div>
               </Navbar.Brand>
            <Navbar.Toggle aria-controls="navbar-nav"/>
            <Navbar.Collapse id="navbar-nav" className="justify-content-end">
               <Nav className="mt-3" onClick={this.setNavClose}>                  
                  <NavLink className="mr-lg-2 mr-xl-3 mb-3" to="/" data-toggle="collapse">Home</NavLink>
                  <NavDropdown title="A Secretaria" id="basic-nav-dropdown" className="mr-lg-2 mr-xl-3 mb-3">
                     <NavDropdown.Item href="./o-secretario">O Secretário</NavDropdown.Item>
                     <NavDropdown.Item href="./organograma">Organograma</NavDropdown.Item>
                     <NavDropdown.Item href="http://sigp.aparecida.go.gov.br/sig/app.html#/servicosonline/ouvidoria" target="_blank">Ouvidoria</NavDropdown.Item>
                  </NavDropdown>    
                  <NavLink className="mr-lg-2 mr-xl-3 mb-3" to="/vagas">Vagas de Emprego</NavLink>
                  <NavLink className="mr-lg-2 mr-xl-3 mb-3" to="/mentorias">Mentorias </NavLink>
                  <NavLink className="mr-lg-2 mr-xl-3 mb-3" to="/cursos">Cursos </NavLink>
                  <NavLink className="mr-lg-2 mr-xl-3 mb-3" to="/noticias">Notícias</NavLink>
                  <Nav.Link className="mr-lg-2 mr-xl-3 mb-3" href="https://webio.aparecida.go.gov.br/login" target="_blank">Anuncie sua Vaga</Nav.Link>
                  <Link className="mr-lg-2 mr-xl-3 mb-3" to="#contact">Fale Conosco</Link>
                  <Link className="mr-lg-2 mr-xl-3 mb-3" to="/faq">FAQ</Link>
               </Nav>
            </Navbar.Collapse>
         </Navbar>
      </Container>
   </div>
    );
  }
}
